import { ISite } from "../../../apiFacades/csu/site";
import { TranslationMatrix } from "../matrixCalculator/types";

export const isEpsg = (str: string) => !!str.match(/^\d\d\d\d\d?\d?$/i);

export const isFloat = (str: string): boolean => {
  const floatRegex = /^[+-]?(\d+\.?\d*|\.\d+)([eE][+-]?\d+)?$/;
  return floatRegex.test(str);
};

export const getEpsgFromSite = (site: ISite): string | undefined => {
  if (!site.srs) {
    return undefined;
  }

  if (site.srs.globalSrs) {
    return site.srs.globalSrs.epsg;
  }

  if (site.srs.assumedSrs) {
    return site.srs.assumedSrs.intermediateSrsEpsg;
  }

  throw new Error("Invalid CRS object");
};

export const getTranslationMatrixFromSite = (
  site: ISite,
): TranslationMatrix | undefined => {
  if (!site.srs) {
    return undefined;
  }

  if (site.srs.globalSrs) {
    return undefined;
  }

  if (site.srs.assumedSrs) {
    return site.srs.assumedSrs.translationMatrixToIntermediateSrs;
  }

  throw new Error("Invalid CRS object");
};
